var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-header-user"},[_c('a-space',{attrs:{"size":10}},[_c('userModal')],1),_vm._v(" "),_c('giftModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }